import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { formatDate } from "../functions/DateConverter";

function useSalesData() {
  const [todayDate, setTodayDate] = useState(null);
  const [currentDate, setCurrentDate] = useState(null);
  const [todayValue, setTodayValue] = useState(null);
  const [rankCompareValue, setRankCompareValue] = useState(null);
  const [rankDetailValue, setRankDetailValue] = useState(null);
  const [lastDetailValue, setLastDetailValue] = useState(null);
  const [menuObject, setMenuObject] = useState({});
  const [isLoadingState, setIsLoadingState] = useState(true);
  const validDateList = useSelector((state) => state.sale.validDateList);
  const isLoading = useSelector((state) => state.sale.isLoading);
  const totalData = useSelector((state) => state.sale.totalData);
  const [predictValue, setPredictValue] = useState({
    daily: {},
    weekly: {},
    monthly: {},
  });

  useEffect(() => {
    if (!isLoading) {
      setTodayDate(formatDate(new Date()));
      setCurrentDate(totalData["date"]);
      setTodayValue(totalData["today"]);
      setRankCompareValue(totalData["rankCompare"]);
      setPredictValue(totalData["predict"]);
      setRankDetailValue(totalData["rankDetail"]);
      if (totalData["menuList"].length !== 0) {
        const menuList = totalData["menuList"];
        let obj = {};
        menuList.forEach((element) => {
          obj[element.name] = { price: element.price, img: element.img };
        });
        setMenuObject(obj);
      }

      setLastDetailValue(totalData["lastDetail"]);
      setIsLoadingState(false);
    } else {
      setIsLoadingState(true);
    }
  }, [isLoading, totalData]);

  return {
    todayDate,
    currentDate,
    isLoadingState,
    todayValue,
    predictValue,
    rankDetailValue,
    rankCompareValue,
    menuObject,
    lastDetailValue,
    validDateList,
  };
}

export default useSalesData;
